import React, { useEffect } from 'react';
import Modal from 'components/Modal';
import Form from 'components/ChangeSecretQuestionModal/Form';
import { StyledLongBody } from 'components/ChangePassewordModal/styles';
import { createStructuredSelector } from 'reselect';
import { get } from 'lodash';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'components/ChangeSecretQuestionModal/messages';
import { getQuestionSecret } from 'store/credentials/actions';
import {
  getQuestionSecretSelector,
  getIsLoadingQuestionSelector,
} from 'store/credentials/selectors';
import { connect } from 'react-redux';

const ChangeSecretQuestion = (props: ChangeSecretQuestionModalType) => {
  useEffect(() => {
    props.getQuestionSecret();
    // eslint-disable-next-line
  }, []);
  return (
    <Modal
      open={props.isOpen}
      handleClose={props.closeModal}
      header={
        <StyledLongBody weight="500" color="#04336B">
          {translate(get(messages, 'title'), props)}
        </StyledLongBody>
      }
      content={
        <Form
          changeSecretQuestion={props.changeSecretQuestion}
          handleClose={props.closeModal}
          isLoading={props.isLoading}
          questionsSecret={props.questionsSecret}
        />
      }
    />
  );
};

export interface ChangeSecretQuestionModalType {
  isOpen: boolean;
  intl: IntlShape;
  closeModal: Function;
  changeSecretQuestion: Function;
  isLoading: boolean;
  questionsSecret: QuestionSecret[];
  isLoadingQuestions: boolean;
  getQuestionSecret: Function;
}

export type QuestionSecret = {
  label: string;
  value: string;
};

const mapStateToProps = createStructuredSelector<
  any,
  { questionsSecret: QuestionSecret[]; isLoadingQuestions: boolean }
>({
  questionsSecret: getQuestionSecretSelector,
  isLoadingQuestions: getIsLoadingQuestionSelector,
});

const mapDispatchToProps = {
  getQuestionSecret,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ChangeSecretQuestion));
